import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { connect } from "react-redux";
import {
  ApprovalPayloadType,
  EditDisbursementPayloadType,
  SingleDisbursementPayloadType,
} from "../../commonTypes/disbursementsTypes";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
} from "../../components/commons";
import { AddEditDisbursementForm } from "../../components/DisbursementModule/DisbursementModuleForm";
import { resetSession } from "../../redux/auth";
import {
  resetDisbursementsError,
  resetDisbursementsMessage,
  resetDisbursementsStatusCode,
  resetDisbursementsSuccess,
  editDisbursementsAction,
  resetSingleDisbursement,
  getSingleDisbursementAction,
  approveDisbursementAction,
  resetApprovalMessage,
  resetApprovalSuccess,
  resetDisbursementList,
  resetSharedDisbursementList,
} from "../../redux/disbursements";
import { SingleDisbursementsListType } from "../../redux/disbursements/disbursementsType";
import { RootState } from "../../redux/rootReducers";
import { handleDate } from "../../utils/commonFunctions";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
type AppProps = {
  history: any;
  token: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  singleDisbursement: [] | SingleDisbursementsListType[];
  approvalSuccess: number | null;
  dispatchResetDisbursementsSuccess: () => void;
  dispatchResetDisbursementsError: () => void;
  dispatchResetDisbursementsMessage: () => void;
  dispatchResetDisbursementsStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchEditDisbursementsAction: (data: EditDisbursementPayloadType) => void;
  dispatchGetSingleDisbursementAction: (
    data: SingleDisbursementPayloadType
  ) => void;
  dispatchApproveDisbursementAction: (data: ApprovalPayloadType) => void;
  dispatchResetSingleDisbursement: () => void;
  dispatchResetApprovalMessage: () => void;
  dispatchResetApprovalSuccess: () => void;
  dispatchResetDisbursementList: () => void;
  dispatchResetSharedDisbursementList: () => void;
  activetab: string;
};
const EditDisbursement = ({
  history,
  token,
  statusCode,
  success,
  error,
  approvalSuccess,
  singleDisbursement,
  dispatchResetDisbursementsSuccess,
  dispatchResetDisbursementsError,
  dispatchResetDisbursementsMessage,
  dispatchResetDisbursementsStatusCode,
  dispatchResetSession,
  dispatchEditDisbursementsAction,
  dispatchResetSingleDisbursement,
  dispatchGetSingleDisbursementAction,
  dispatchApproveDisbursementAction,
  dispatchResetApprovalMessage,
  dispatchResetApprovalSuccess,
  dispatchResetDisbursementList,
  dispatchResetSharedDisbursementList,
  activetab,
}: AppProps) => {
  const tab = history?.location?.state?.activeTab;
  const disbursementId = history?.location?.state?.data;
  const approvalValue = history?.location?.state?.filterApproval;
  const attachmentValue = history?.location?.state?.filterAttachmentValue;
  const searchData = history?.location?.state?.searchData;
  const allPaymentStatus = history?.location?.state?.allPaymentStatus;
  const paymentStatus = history?.location?.state?.paymentStatus;
  const [date, setDate] = useState(null);
  const handleDateChange = (date: any) => {
    const value = handleDate(date);
    setDate(value);
  };
  //====================User Management=============================
  const [isGetSingleDisbursementPresent, setIsGetSingleDisbursementPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    setIsGetSingleDisbursementPresent("Get Single Disbursement", "menu");
    dispatchResetDisbursementsSuccess();
    dispatchResetDisbursementsError();
    dispatchResetDisbursementsMessage();
    dispatchResetDisbursementsStatusCode();
    dispatchResetSingleDisbursement();
    dispatchResetApprovalMessage();
    dispatchResetApprovalSuccess();
    if (token) {
      const finalData = {
        token,
        disbursement_id: disbursementId,
      };
      dispatchGetSingleDisbursementAction(finalData);
    }
  }, []);

  const handleDisbursementApproval = (data: ApprovalPayloadType) => {
    dispatchApproveDisbursementAction(data);
  };

  const handleEditDisbursement = (data: EditDisbursementPayloadType) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchEditDisbursementsAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetDisbursementsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Disbursement Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetDisbursementsSuccess();
            dispatchResetDisbursementList();
            dispatchResetSharedDisbursementList();
            history?.push({
              pathname: "/disbursement-module",
              state: {
                tab,
                approvalValue,
                attachmentValue,
                searchData,
                allPaymentStatus,
                paymentStatus,
              },
            });
          }}
          statusCode={statusCode}
        />
      );
    }
    if (approvalSuccess) {
      dispatchResetApprovalSuccess();
      toast.success("Approved successfully!", {
        duration: 2000,
      });
      if (token) {
        const finalData = {
          token,
          disbursement_id: disbursementId,
        };
        dispatchGetSingleDisbursementAction(finalData);
      }
    }
    return false;
  };
  return (
    <>
      <CommonHeader title="Edit Disbursement" />
      {isGetSingleDisbursementPresent && (
        <ContentArea>
          <AddEditDisbursementForm
            history={history}
            date={date}
            setDate={setDate}
            handleDateChange={handleDateChange}
            singleDisbursement={singleDisbursement}
            handleEditDisbursement={handleEditDisbursement}
            handleDisbursementApproval={handleDisbursementApproval}
            tab={tab}
            attachmentValue={attachmentValue}
            approvalValue={approvalValue}
            allPaymentStatus={allPaymentStatus}
            paymentStatus={paymentStatus}
          />
        </ContentArea>
      )}
      {handleErrorModal()}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.disbursements.success,
  statusCode: state.disbursements.statusCode,
  error: state.disbursements.error,
  singleDisbursement: state.disbursements.singleDisbursement,
  approvalSuccess: state.disbursements.approvalSuccess,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetDisbursementsSuccess: () =>
    dispatch(resetDisbursementsSuccess()),
  dispatchResetDisbursementsError: () => dispatch(resetDisbursementsError()),
  dispatchResetDisbursementsMessage: () =>
    dispatch(resetDisbursementsMessage()),
  dispatchResetDisbursementsStatusCode: () =>
    dispatch(resetDisbursementsStatusCode()),
  dispatchEditDisbursementsAction: (data: EditDisbursementPayloadType) =>
    dispatch(editDisbursementsAction(data)),
  dispatchGetSingleDisbursementAction: (data: SingleDisbursementPayloadType) =>
    dispatch(getSingleDisbursementAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSingleDisbursement: () => dispatch(resetSingleDisbursement()),
  dispatchResetApprovalMessage: () => dispatch(resetApprovalMessage()),
  dispatchResetApprovalSuccess: () => dispatch(resetApprovalSuccess()),
  dispatchApproveDisbursementAction: (data: ApprovalPayloadType) =>
    dispatch(approveDisbursementAction(data)),
  dispatchResetDisbursementList: () => dispatch(resetDisbursementList()),
  dispatchResetSharedDisbursementList: () =>
    dispatch(resetSharedDisbursementList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditDisbursement);
